import { render } from "./banner.vue?vue&type=template&id=f1346620&scoped=true"
import script from "./banner.vue?vue&type=script&lang=js"
export * from "./banner.vue?vue&type=script&lang=js"

import "./banner.vue?vue&type=style&index=0&id=f1346620&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1346620"]])

export default __exports__